import { render, staticRenderFns } from "./ActionsInfo.vue?vue&type=template&id=03d8c347&scoped=true&"
import script from "./ActionsInfo.vue?vue&type=script&lang=js&"
export * from "./ActionsInfo.vue?vue&type=script&lang=js&"
import style0 from "./ActionsInfo.vue?vue&type=style&index=0&id=03d8c347&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d8c347",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
